<div id="cinico-dropdown" *ngIf="{ control: controlObs | async } as data">
  <div class="dropdown-container">
    <span *ngIf="showLabel">{{ label | translate }}</span>
    <div #controlInput class="control-container" (click)="expandOrCollapse()">
      <ng-container *ngIf="enableSearch; else elseTemplate">
        <input
          [formControl]="control"
          type="text"
          class="cursor-pointer"
          [placeholder]="placeholder" />
        <ng-container *ngIf="control.value; else elseTemplateIcon">
          <span class="material-symbols-outlined" (click)="clearSearch()"> close_small </span>
        </ng-container>
        <ng-template #elseTemplateIcon>
          <span class="material-symbols-outlined">
            {{ isExpanded ? 'stat_1' : 'stat_minus_1' }}
          </span>
        </ng-template>
      </ng-container>
      <ng-template #elseTemplate>
        <div [ngClass]="{ disabled: isDisabled }">
          <div #multiselectValueDisplay [ngClass]="{ 'ellipsis-limit': isMultiselect }">
            <span [ngClass]="{ 'ellipsis-text': isMultiselect }">{{ displayValue() }}</span>
          </div>
        </div>
      </ng-template>

      <span *ngIf="!enableSearch" class="material-symbols-outlined">
        {{ isExpanded ? 'stat_1' : 'stat_minus_1' }}
      </span>
    </div>
    <!-- treba da se doda kada se odobri -->
    <!-- <div *ngIf="control.errors && control.touched && isTouched" class="error-container">
      <ng-container *ngIf="getError() as error">
        <span *ngIf="error === 'errors.required'">{{ label | translate }}</span>
        <span>{{ error | translate }}</span>
      </ng-container>
    </div> -->
  </div>

  <!-- treba da se doda u dropdown-items div -->
  <!-- [ngStyle]="{ top: control.errors && control.touched && isTouched ? '-26px' : '2px' }"> -->

  <div class="items-container">
    <mat-card class="dropdown-items" *ngIf="isExpanded && !isDisabled">
      <div>
        <ul *ngIf="!isMultiselect; else multiSelectTemplate">
          <li *ngFor="let item of itemList" (click)="valueChange(item)">
            <span>{{ item.value }}</span>
          </li>
        </ul>
      </div>
    </mat-card>
  </div>
</div>

<ng-template #multiSelectTemplate>
  <ul *ngIf="isMultiselect" (click)="preventClosing()" fxLayout="column">
    <li (click)="clearSelection()" fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center">
      <span class="material-symbols-outlined"> delete </span>
      <span>{{ clearText }}</span>
    </li>
    <li
      *ngFor="let item of itemList"
      (click)="valueChange(item)"
      fxLayout="row"
      fxLayoutAlign="start start"
      fxLayoutGap="10px">
      <input type="checkbox" class="custom-checkbox" [checked]="isItemChecked(item)" />
      <span>{{ item.value }}</span>
    </li>
  </ul>
</ng-template>
